import Phaser from 'phaser';
import { coalesceHudRefresh } from '../net/schedule';

const bus = new Phaser.Events.EventEmitter();

export const GameEvents = {
  PANEL_REQUEST: 'panel-request',
  PANEL_CHANGED: 'panel-changed',
  HUD_REFRESH: 'hud-refresh',
  GEODE_BREAK: 'geode-break',
  GEODE_HIT: 'geode-hit',
  GEODE_RESPAWN: 'geode-respawn',
  GEODE_SYNC: 'geode-sync',
  SERVER_DROPS: 'server-drops',
  FORGE_OPEN: 'forge-open',
  INVENTORY_OPEN: 'inventory-open',
  GAME_READY: 'game-ready',
} as const;

export function emitGame(event: string, payload?: unknown) {
  bus.emit(event, payload);
}

export function onGame(event: string, fn: (...args: unknown[]) => void, context?: unknown) {
  bus.on(event, fn, context);
}

export function onceGame(event: string, fn: (...args: unknown[]) => void, context?: unknown) {
  bus.once(event, fn, context);
}

export function offGame(event: string, fn: (...args: unknown[]) => void, context?: unknown) {
  bus.off(event, fn, context);
}

export function refreshHudCoalesced(refresh: () => void) {
  coalesceHudRefresh(refresh);
}
